var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { "grid-list-lg": "" } },
    [
      _c("h6", [_vm._v("Station " + _vm._s(_vm.name) + " Dashboard")]),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "ma-4 elevation-5" },
        [
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                [
                  _c("v-flex", { attrs: { lg6: "", "offset-lg3": "" } }, [
                    _c("p", { staticClass: "text-lg-center" }, [
                      _vm._v("station map"),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", lg6: "" } }, [_c("chart")], 1),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs12: "", lg6: "" } }, [_c("chart")], 1),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", lg6: "" } }, [_c("chart")], 1),
          _vm._v(" "),
          _c("v-flex", { attrs: { xs12: "", lg6: "" } }, [_c("chart")], 1),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }